<template>
    <CustomDialog
        :modelValue="show"
        scrollClass="custom-scroll-y h-full max-mob:pb-20"
        hideHeader
        hideFooter
        persistent
        hideCloseIcon
    >
        <div class="max-mob:px-4 p-7.5">
            <div
                v-if="verificationUserStore.loading"
                class="flex flex-col gap-y-4 justify-end items-end"
            >
                <SkeletonBlock width="max-mob:w-full w-105" height="h-10" />
                <SkeletonBlock width="max-mob:w-full w-105" height="h-40" />
                <SkeletonBlock width="max-mob:w-full w-105" height="h-40" />
                <SkeletonBlock width="w-30" height="h-10" />
            </div>

            <template v-else>
                <IntroductoryView
                    v-if="currentStep.id === views.introductoryView.id"
                    @startVerification="startVerification"
                    @close="closeVerification"
                />

                <VerificationView
                    v-else-if="currentStep.id === views.verifyView.id"
                    @close="closeVerification"
                    @openReviewView="openReviewView"
                />

                <ReviewView
                    v-else-if="currentStep.id === views.reviewView.id"
                    @close="closeVerification"
                />
            </template>
        </div>
    </CustomDialog>
</template>

<script setup>
import { computed, ref, watch } from 'vue'

import CustomDialog from '@/components/dialogs/CustomDialog.vue'
import IntroductoryView from '@/views/verification/views/IntroductoryView.vue'
import VerificationView from '@/views/verification/views/VerificationView.vue'
import ReviewView from '@/views/verification/views/ReviewView.vue'
import SkeletonBlock from '@/components/skeletonBlock/SkeletonBlock.vue'

import { useVerificationUserStore } from '@/store/call-tracking/verificationUserStore'

const show = defineModel('modelValue', { type: Boolean, default: false })

const verificationUserStore = useVerificationUserStore()

const views = computed(() => ({
    introductoryView: {
        id: 1,
    },
    verifyView: {
        id: 2,
    },
    reviewView: {
        id: 3,
    },
}))

const currentStep = ref(views.value.reviewView)

function startVerification() {
    currentStep.value = views.value.verifyView
}

function openReviewView() {
    currentStep.value = views.value.reviewView
}

function closeVerification() {
    show.value = false
}

async function loadVerificationData() {
    const { success } = await verificationUserStore.goToLoadVerificationData()

    if (success) {
        currentStep.value = setCurrentView()
    }
}

function setCurrentView() {
    switch (true) {
    case (verificationUserStore.billingStepDone && verificationUserStore.paymentStepDone):
        return views.value.reviewView
    case verificationUserStore.billingStepDone:
        return views.value.verifyView
    default:
        return views.value.introductoryView
    }
}

watch(show, (value) => {
    if (value) {
        loadVerificationData()
    } else {
        verificationUserStore.$reset()
    }
}, { immediate: true })

watch(() => verificationUserStore.reviewStep, (value) => {
    if (value) {
        startVerification()
    }
}, { immediate: true })
</script>
